document.addEventListener('DOMContentLoaded', () => {

    const sliders = document.querySelectorAll('.dbbk-menu');

    sliders.forEach((slider) => {
    });
});